<template>
  <ca-page>
    <ca-row>
      <ca-col offset="5" size="2">
        <ca-illustration name="account-success" width="150"></ca-illustration>
      </ca-col>
    </ca-row>
    <ca-row>
      <ca-col class="ca-u-text-center">
        <ca-heading
          size="medium"
          :text="getConcludeWizardText.title"></ca-heading>
        <p>
          {{ getConcludeWizardText.text }}
        </p>
      </ca-col>
    </ca-row>
    <ca-row>
      <ca-col offset="1" size="5">
        <ca-button
          theme="secondary"
          class="ca-u-margin-bottom"
          full-width
          @click="onWorkerList">
          Cadastrar depois, ver lista de funcionários
        </ca-button>
      </ca-col>
      <ca-col size="5">
        <ca-button
          theme="primary"
          class="ca-u-margin-bottom"
          full-width
          @click="onRegistrationWorker">
          Cadastrar dados pessoais
        </ca-button>
      </ca-col>
    </ca-row>
    <ca-row>
      <ca-col size="4" offset="4">
        <worker-feedback></worker-feedback>
      </ca-col>
    </ca-row>
  </ca-page>
</template>

<script>
import {
  getConcludeWizardText,
  getWorkerDraft,
  hasWorkerDraft,
  setWorkerDraft,
} from '../workersService';

import WorkerFeedback from './WorkerFeedback.vue';

export default {
  name: 'ConcludeWizardStep',
  components: {
    WorkerFeedback,
  },
  computed: {
    getConcludeWizardText,
    workerId() {
      return getWorkerDraft()?.workerId;
    },
  },
  created() {
    if (!hasWorkerDraft()) {
      this.$emit('on-reset-steps');
    }
  },
  methods: {
    onWorkerList() {
      this.$router.replace({ name: 'WorkerPage' });
    },
    onRegistrationWorker() {
      this.$router.replace({
        name: 'WorkerRegistrationForm',
        params: {
          id: this.workerId,
        },
      });
    },
    clearWorkerDraft() {
      setWorkerDraft({}, true);
    },
  },
};
</script>
